import { CalculateVenue } from '@/domain/impact-calculate-venue/entities/calculate-venue.entity.ts';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  projectId: number;
};

export const getImpactCalculateVenueCo2ForProject = createAppAsyncThunk(
  'impactCalculateVenue/getImpactCalculateVenueCo2ForProject',
  async (
    params: Params,
    { extra: { impactCalculateVenueGateway, snackbarGateway } },
  ): Promise<CalculateVenue> => {
    try {
      return await impactCalculateVenueGateway.getVenueResultsForProject(
        params.projectId,
      );
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCalculate.Message.error'));
}
